export const mutations = {
    SET_LIST: (state, categoryServices) => (state.list = categoryServices),
};
